import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import store from '../store'
import {
  getParameterValue
} from '@/utils/auth' // get token from cookie
import {
  setToken, getToken, setUser, setUserID, getUserID
} from '@/utils/auth' // get token from cookie
import {
  getByUname
} from '@/api/getByUname'
import {getIp} from '@/api/home'
Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

let homeTitle = ''
getIp().then(res => {
  homeTitle = res.array[2].param_value
})


export const constantRoutes = [
  {
    path: '/',
    name: 'container',
    redirect: '/container',
    meta: {
      title: '信息发布网站home',
      icon: 'peoples'
    }
  },
  // {
  //   path: '/',
  //   name: 'releaseConfig',
  //   component: Layout,
  //   redirect: '/releaseManagement',
  //   meta: {
  //     title: '发布管理',
  //     icon: 'peoples'
  //   }
  // },
  {
    path: '/container',
    name: 'container',
    redirect: '/container/home',
    component: () => import('@/components/container.vue'),
    meta: {
      title: '信息发布网站',
      icon: 'peoples',
      loginAuthority: true
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home.vue'),
        meta: {
          title: 'Home',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'aboutEP',
        name: 'aboutEP',
        component: () => import('@/views/aboutEP.vue'),
        meta: {
          title: 'About',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/news/news.vue'),
        meta: {
          title: 'News',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'news/detail',
        name: 'newsDetail',
        component: () => import('@/views/news/newsDetail.vue'),
        meta: {
          title: 'NewsDetail',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'pubs',
        name: 'pubs',
        component: () => import('@/views/pubs/pubs.vue'),
        meta: {
          title: 'Pubs',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'pubs/detail',
        name: 'pubsDetail',
        component: () => import('@/views/pubs/pubsDetail.vue'),
        meta: {
          title: 'PubsDetail',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'dataPolicy',
        name: 'dataPolicy',
        component: () => import('@/views/dataPolicy/index.vue'),
        meta: {
          title: 'Data Policy',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'publishtrends',
        name: 'publishtrends',
        component: () => import('@/views/publishtrends/index.vue'),
        meta: {
          title: 'publishtrends',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'publishDetails',
        name: 'publishDetails',
        component: () => import('@/views/publishtrends/proDetails.vue'),
        meta: {
          title: 'publishDetails',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'links',
        name: 'links',
        component: () => import('@/views/links.vue'),
        meta: {
          title: 'Links',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'tools',
        name: 'tools',
        component: () => import('@/views/tools/index.vue'),
        meta: {
          title: 'Tools',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'softDetails',
        name: 'softDetails',
        component: () => import('@/views/tools/softDetails.vue'),
        meta: {
          title: 'softDetails',
          icon: 'peoples',
          loginAuthority: true
        }
      },
      {
        path: 'dataRetrieval',
        name: 'dataRetrieval',
        component: () => import('@/views/data/index.vue'),
        meta: {
          title: 'Data',
          icon: 'peoples',
          loginAuthority: true
        }
      }
    ]
  },
  {
    path: '/releaseManagement',
    component: Layout,
    redirect: '/releaseManagement/releaseCount',
    name: 'releaseCount',
    meta: {
      title: '发布管理',
      icon: 'peoples'
      // roles: ['ADMIN']
    },
    children: [
      {
        path: 'releaseCount',
        name: 'releaseCount',
        // @ts-ignore
        component: () => import('@/views/releaseCount.vue'),
        meta: {
          title: '发布统计',
          icon: 'peoples'
        }
      },
      {
        path: 'releaseConfig',
        name: 'releaseConfig',
        // @ts-ignore
        component: () => import('@/views/releaseMang/releaseConfig.vue'),
        redirect: '/releaseManagement/releaseConfig/faqConfig',
        meta: {
          title: '发布配置'
        },
        children: [{
          path: 'faqConfig',
          name: 'faqConfig',
          component: () => import('@/views/releaseMang/faqConfig.vue'),
          meta: {
            title: 'faq配置',
            icon: 'peoples'
          }
        },
        {
          path: 'urlConfig',
          name: 'urlConfig',
          component: () => import('@/views/releaseMang/urlConfig.vue'),
          meta: {
            title: 'url配置',
            icon: 'peoples'
          }
        },
        {
          path: 'softConfig',
          name: 'softConfig',
          component: () => import('@/views/releaseMang/softConfig.vue'),
          meta: {
            title: '软件配置',
            icon: 'peoples'
          }
        },
        {
          path: 'pubDynamic',
          name: 'pubDynamic',
          component: () => import('@/views/releaseMang/pubDynamic.vue'),
          meta: {
            title: '发布动态配置',
            icon: 'peoples'
          }
        }
        ]
      }

    ]
  },
  {
    path: '/noPermission',
    name: 'noPermission',
    component: () => import('@/views/noPermission'),
    meta: {
      title: 'noPermission',
      closed: true,
      loginAuthority: true
    }
  }
  // {
  //   path: '/second',
  //   name: 'secondIndex',
  //   component: secondIndex,
  //   redirect: '/Index',//设置默认指向的路径
  //   children: [ //这里就是二级路由的配置
  //     {
  //       path: '/talent',
  //       name: 'TalentMain',
  //       component: TalentMain
  //     }
  //   ]
  // },

]

const createRouter = () => new Router({
  // base: '/asos_client/',
  routes: constantRoutes
  // mode: "history"
})
const router = createRouter()

router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title + ' | EP')
  const jsid = getParameterValue('jsessionid')
  const cu = getParameterValue('cu')
  const userID = getParameterValue('userId')
  // 如果url上用户名 cu userId到本地
  if (!!jsid && !!cu) {
    setToken(jsid)
    setUser(cu)
    setUserID(userID)
    window.sessionStorage.setItem('cu', cu)
  }
  window.sessionStorage.setItem('userID', getUserID())
  store.dispatch('app/setUser')
  const hasToken = getToken()
  // 个人空间和后台系统需要登录 loginAuthority为true就是可以免登陆
  if (!to.meta.loginAuthority) {
    window.sessionStorage.setItem('sign', 'asos_service')
    if (!hasToken) {
      // window.location.href = process.env.VUE_APP_CAS_LOGIN_BACK
    } else {
      getByUname().then(res => {
        if (res.data) {
          if (res.data.indexOf('admin') > -1) {
            next()
          } else {
            next({
              path: '/noPermission'
            })
          }
        }
      })
    }
  } else {
    next()
  }

  // next() // 继续执行
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js